import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { useLocation, useNavigate } from 'react-router-dom'
import type { ParsedQuery } from 'query-string'

import { PageLoadingState } from 'Components/PageLoadingState/PageLoadingState'

import { fetchFromPublicApiUsingPartialPath, getQueryObject } from 'Utilities'

import { setRouteTitle } from 'Portal/src/router/Router.utils'

import { OfferError } from '../OfferError/OfferError.page'
import type { OfferParsedSearch, OfferResponse } from './Offer.types'

export const Offer = () => {
  const [isError, setIsError] = useState(false)
  const navigate = useNavigate()
  const { search: locationSearch } = useLocation()
  const intl = useIntl()

  const parsedSearch: ParsedQuery | null = getQueryObject(locationSearch)
  const { uuid, accept } = parsedSearch as unknown as OfferParsedSearch
  const accepted = accept === 'true'

  useEffect(() => {
    const fetchFromApi = async () => {
      try {
        const response =
          await fetchFromPublicApiUsingPartialPath<OfferResponse>(
            `/purchase-device/${uuid}/${accepted ? 'accept' : 'decline'}`,
            { method: 'POST' },
          )

        if (response.recreate_offer) {
          navigate('/offer-recreated', { replace: true })

          return
        }

        if (response.success && accepted) {
          navigate('/offer-accepted', { replace: true })
        }

        if (response.success && !accepted) {
          navigate('/offer-declined', { replace: true })
        }

        if (!response.success) {
          throw new Error(response.error)
        }
      } catch (error) {
        setIsError(true)
      }
    }

    fetchFromApi()
  }, [accepted, navigate, uuid])

  useEffect(() => {
    setRouteTitle(
      intl.formatMessage({
        id: isError ? 'OfferErrorContent_heading' : 'Loading',
      }),
    )
  }, [accepted, intl, isError])

  if (isError) {
    return <OfferError />
  }

  return <PageLoadingState />
}
